export default __webpack_public_path__ + "static/media/iotecha-logo.dd54e4c4.svg";